import {ToNamePipe, User, VereinService} from 'kkm-library';
import {Component, OnInit, inject} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {lastValueFrom} from 'rxjs';

@Component({
    templateUrl: './vorstand-page.component.html',
    styleUrls: ['./vorstand-page.component.scss'],
    imports: [MatCardModule, ToNamePipe],
})
export class VorstandPageComponent implements OnInit {
    private vereinsService = inject(VereinService);

    public vorstand: {
        ersterVorsitzender?: User;
        zweiterVorsitzender?: User;
        kassenwart?: User;
        schriftfuehrer?: User;
        bootshauswart?: User;
        wanderwart?: User;
        sportwart?: User;
        webbeauftragter?: User;
    } = {};

    ngOnInit(): void {
        this.initVorstandData();
    }

    async initVorstandData(): Promise<void> {
        this.vorstand = await lastValueFrom(this.vereinsService.getVorstand());
        return;
    }
}
